import PageHero from "@/components/layout/PageHero";
import About from "@/components/sections/About";
import Differentials from "@/components/sections/Differentials";
import TargetAudience from "@/components/sections/TargetAudience";

const Sobre = () => (
  <>
    <PageHero
      eyebrow="Quem somos"
      title="Sobre a Finegraf"
      description="Acabamentos gráficos com precisão, tecnologia e prazo cumprido — para gráficas, embalagens, agências, designers e empresas."
    />
    <About />
    <Differentials />
    <TargetAudience />
  </>
);

export default Sobre;
